import React from 'react'

export default () => (
<svg width="167" height="14" viewBox="0 0 185 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<g>
    <path d="M10 14L6.47141e-07 7.01266L10 0L10 14Z" fill="#1A98FF"/>
</g>
<g>
    <path d="M8 7H177" stroke="#1A98FF" strokeWidth="1.5" strokeMiterlimit="10" strokeDasharray="10 10"/>
</g>
<g>
    <path d="M175 0L185 6.98734L175 14L175 0Z" fill="#1A98FF"/>
</g>
</svg>
)
